import React, {FC} from "react"
import {Redirect, Route, Switch} from "react-router-dom"
import {NestedRoute} from "@irati/utils/history/routing"
import AppContainer from "@irati/ui/src/AppContainer"
import {LangLoader, useIntl} from "@irati/utils/lang"
import {MEDICAL} from "@irati-web/app/src/routeConfig"
import {OnlineGp} from "./OnlineGp"

interface Props {
  path: string
}

const OnlineGPRoutes: FC<Props> = ({path}) => {
  const {formatMessage, messages} = useIntl()
  const isI18nLoaded = "medical.onlinegp.headers.onlinegp" in messages
  return (
    <LangLoader buckets={[MEDICAL]}>
      <Route
        path={path}
        render={() => (
          <AppContainer
            mainBackground={`top right  / contain no-repeat #F4F4F7 url("${isI18nLoaded && formatMessage({id: "medical.onlinegp.bgimage"})}")`}>
            <Switch>
              <NestedRoute
                permissions="medical.onlineGP"
                match={path}
                exact
                path={path}
                component={OnlineGp}
                title={isI18nLoaded ? formatMessage({id: "medical.onlinegp.headers.onlinegp"}) : ""}
              />
              <Redirect to={path} />
            </Switch>
          </AppContainer>
        )}
      />
    </LangLoader>
  )
}

export default OnlineGPRoutes
